<template>
  <v-container>
    <div v-if="!admin">
      <v-row justify="center">
        <v-col xs="10" sm="10" md="10" lg="6" xl="6">
          <p class="text-center text-h4 font-weight-bold">{{mainHead}}</p>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" xs="12" sm="12" md="10" lg="6" xl="6">

          <v-row>
            <v-col xs="6" sm="6" md="6" lg="6" xl="6">
              <v-btn block depressed @click="enableDates">
                {{ t.setDate }}
              </v-btn>
            </v-col>
            <v-col xs="6" sm="6" md="6" lg="6" xl="6">
              <v-btn block depressed @click="refreshPeriod">
                {{ t.refresh }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="settingDate">
            <v-col cols="6" class="pr-3">
              <v-dialog
                  ref="dialog1"
                  persistent
                  v-model="modal1"                   
                  width="290px"
                  :return-value.sync="OdDatuma"
                >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="formatDate1"
                    :label="t.dateFrom"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                  <v-date-picker v-model="OdDatuma" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="modal1 = false">{{langC.Cancel}}</v-btn>
                    <v-btn color="primary" @click="$refs.dialog1.save(OdDatuma)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
            </v-col>
            <v-col cols="6" class="pr-3">
              <v-dialog
                  ref="dialog2"
                  persistent
                  v-model="modal2"                   
                  width="290px"
                  :return-value.sync="DoDatuma"
                >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="formatDate2"
                    :label="t.dateTo"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                  <v-date-picker v-model="DoDatuma" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="modal2 = false">{{langC.Cancel}}</v-btn>
                    <v-btn color="primary" @click="$refs.dialog2.save(DoDatuma)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
            </v-col>
          </v-row>

          <v-row v-if="settingDate">
            <v-col cols="12">
              <v-autocomplete
                :items="customers"
                v-model="selectCustomer"
                :label="t.selectCustomer"
                single-line
                item-text="Kupac"
                item-value="Kupac"
                return-object
                persistent-hint
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                :items="constructionSites"
                v-model="selectConstrucitionSite"
                :label="t.selectConSite"
                single-line
                item-text="Gradiliste"
                item-value="Gradiliste"
                return-object
                persistent-hint
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row justify="center" v-if="!settingDate">
        <v-col cols="12" xs="12" sm="12" md="10" lg="6" xl="6">
          <span class="text-h6 ml-2">{{ t.totalProduction }} {{headDate}}
            <v-btn
            text color="primary"
            @click="toExcel">
             {{ t.toExcel }}
          </v-btn>
          </span>
        </v-col>
      </v-row>
      <v-row justify="center" v-if="!settingDate && kupac">
        <v-col cols="12" xs="12" sm="12" md="10" lg="6" xl="6">
          <span class="text-h6 ml-2">{{ t.customerHead }}: {{selectCustomer.Kupac}}</span>
        </v-col>
      </v-row>
      <v-row justify="center" v-if="!settingDate && gradiliste">
        <v-col cols="12" xs="12" sm="12" md="10" lg="6" xl="6">
          <span class="text-h6 ml-2">{{ t.conSite }}: {{selectConstrucitionSite.Gradiliste}}</span>
        </v-col>
      </v-row>
      <v-row justify="center" v-if="!settingDate">
        <v-col cols="12">
          <beton-total :total="totalBeton" />
        </v-col>
      </v-row>
      <div v-if ="!settingDate" class="mt-2">
        <BetonSingle
          v-for="(beton, index) in betoni"
          :name="beton.Objekat"
          :sifraObjekta="beton.ObjekatID"
          :amount="beton.totalKolicina"
          :odDatuma="query.OdDatuma"
          :doDatuma="query.DoDatuma"
          :kupac="kupac"
          :gradiliste="gradiliste"
          :index="index"
          :refreshSignal="refreshSignal"
          :key="beton.ObjekatID"
        />
      </div>
    </div>
    <div v-if="admin">
       <v-row justify="center">
        <v-col cols="12">
          <app-settings />
        </v-col>
       </v-row>
    </div>

  </v-container>

</template>

<script>
import commEn from "@/language/commonEN"
import commHr from "@/language/commonHR"
import BetonTotal from './Beton/BetonTotal.vue'
import BetonSingle from './Beton/BetonSingle.vue'
import BetonService from '@/services/BetonService'
import AppSettings from './AppSettings.vue'
import dateFormat from '@/snippets/dateFormat'
import { utrosciRows, utrosciColumns } from '@/snippets/betonUtrosci'
import { betonT } from '@/snippets/betonLang'
import xlsx from 'json-as-xlsx'


export default {
  name: 'home',
  data () {
    return {
      msg: '',
      head1: '',
      langC: {},
      query: {},
      betoni: [],
      totalBeton: 0,
      admin: false,
      headDate: null,
      settingDate: false,
      modal1: false,
      dialog1: false,
      modal2: false,
      dialog2: false,
      OdDatuma: null,
      DoDatuma: null,
      mainHead: null,
      customers: [],
      selectCustomer: {},
      constructionSites: [],
      selectConstrucitionSite: {},
      kupac: null,
      gradiliste: null,
      refreshSignal: 0
    }
  },
  components: {
    BetonTotal,
    BetonSingle,
    AppSettings
  },
  computed: {
    formatDate1() {
      return this.OdDatuma
        ? dateFormat(this.OdDatuma)
        : "";
    },
    formatDate2() {
      return this.DoDatuma
        ? dateFormat(this.DoDatuma)
        : "";
    },
    canUtrosak () {
      const u = this.$store.state.user
      return !!(u && (u.betonUtrosak || u.admin1))
    },
    t () {
      return betonT(this.$store.state.language)
    },

  },
  async mounted () {
    try {
      if (this.$store.state.language === "EN") {
        this.langC = commEn;
      }
      if (this.$store.state.language === "HR") {
        this.langC = commHr;
      }

      const onlyCustomers = {}
      onlyCustomers.TvrtkaID = this.$store.state.user.tvrtkaID ? this.$store.state.user.tvrtkaID : false
      onlyCustomers.qType = 'Kupci'
      await BetonService.choose(onlyCustomers)
      .then(res => {
        if (res && res.data && res.data.betoni) {
          this.customers = res.data.betoni
        }
      })
      .catch(err => {
        console.log('Error ', err )
      })

      const onlyConstruciton = {}
      onlyConstruciton.TvrtkaID = this.$store.state.user.tvrtkaID ? this.$store.state.user.tvrtkaID : false
      onlyConstruciton.qType = 'Gradilista'
      await BetonService.choose(onlyConstruciton)
      .then(res => {
        if (res && res.data && res.data.betoni) {
          this.constructionSites = res.data.betoni
        }
      })
      .catch(err => {
        console.log('Error ', err )
      })
      
      this.head1 = this.$store.state.companyActiv && this.$store.state.companyActiv.CompanyName ? this.$store.state.companyActiv.CompanyName : ' '
      this.head1 = this.head1 + (this.$store.state.businessYear ? ', ' + this.$store.state.businessYear : '')

      this.admin = this.$store.state.user.admin1 ? this.$store.state.user.admin1 : false
      this.DoDatuma = new Date().toISOString().substr(0,10)
      await this.init()

    }
    catch(err) {
      console.log(err)
    }
  },
  methods: {
    async init() {

      this.totalBeton = 0
      if (!this.mainHead) {
        const onlyComp = {}
        onlyComp.TvrtkaID = this.$store.state.user.tvrtkaID ? this.$store.state.user.tvrtkaID : false
        await BetonService.companyFind(onlyComp)
        .then(res => {
          if (res && res.data && res.data.compBeton) {
            this.mainHead = res.data.compBeton.Tvrtka
          }
        })
        .catch(err => {
          console.log('Error ', err )
        })
      }

      this.query.TvrtkaID = this.$store.state.user.tvrtkaID ? this.$store.state.user.tvrtkaID : false
      
      this.query.OdDatuma = new Date().toISOString().substr(0,10)
      this.query.DoDatuma = new Date().toISOString().substr(0,10)

      if (this.OdDatuma && this.query.OdDatuma !== this.OdDatuma) {
        this.query.OdDatuma = this.OdDatuma
        this.query.DoDatuma = this.DoDatuma
        this.settingDate = false
      }

      this.kupac = null
      this.gradiliste = null
      if (Object.prototype.hasOwnProperty.call(this.query, "Kupac")) {
        delete this.query.Kupac
      }
      if (Object.prototype.hasOwnProperty.call(this.query, "Gradiliste")) {
        delete this.query.Gradiliste
      }

      if (this.selectCustomer && this.selectCustomer.Kupac) {
        this.query.Kupac = this.selectCustomer.Kupac
        this.kupac = this.selectCustomer.Kupac
      }
      if (this.selectConstrucitionSite && this.selectConstrucitionSite.Gradiliste) {
        this.query.Gradiliste = this.selectConstrucitionSite.Gradiliste
        this.gradiliste = this.selectConstrucitionSite.Gradiliste
      }

      const qFrom = this.query.OdDatuma
      const qTo = this.query.DoDatuma 

      this.headDate = qFrom === qTo? this.localDate(qFrom) : this.localDate(qFrom) + ' - ' + this.localDate(qTo)

      

      this.query.qType = "Total"
      await BetonService.choose(this.query)
      .then(res => {
        if (res && res.data && res.data.betoni) {
          this.betoni = res.data.betoni
          this.betoni.forEach(item => { this.totalBeton += parseFloat(item.totalKolicina)})
        }
      })
      .catch(err => {
        console.log('Error ', err )
      })
      // signal otvorenim betonarama da ponovo učitaju kartice
      this.refreshSignal++
    },
    enableDates() {

      this.settingDate = !this.settingDate
    },
    async refreshPeriod() {
      console.log('refresh OdDatuma', this.OdDatuma, typeof this.OdDatuma)
      await this.init()
    },
    localDate(dateToFormat) {
      return this.$moment(dateToFormat).format('DD.MM.YYYY')
    },
    async toExcel() {
      if (this.betoni) {
        const lang = this.$store.state.language
        const t = betonT(lang)
        let sheetNm = ''
        let fileNm = ''
        const newArr =[]
        console.log('this.betoni', this.betoni)

        this.betoni.map(item => {
          const newI = {}
          newI.Objekat = item.Objekat
          newI.totalKolicina = item.totalKolicina
          newI.period = this.headDate
          newArr.push(newI)
        })

        const period = this.query.OdDatuma === this.query.DoDatuma ? this.localDate(this.query.OdDatuma) : this.localDate(this.query.OdDatuma) + '-' + this.localDate(this.query.DoDatuma)
        sheetNm =  t.sheetPlants
        fileNm = t.sheetPlants + '_' + period
        let data = [
        {
          sheet: sheetNm,
          columns: [
            {label: t.plantName, value: 'Objekat' },
            {label: t.totalM3, value: 'totalKolicina' },
            {label: t.period, value: 'period' },
          ],
          content: newArr
        }
      ]

      // utrošak materijala samo ako korisnik ima dozvolu
      if (this.canUtrosak) {
        let sveOtpremnice = []
        const detailQuery = { ...this.query, qType: 'Detail' }
        await BetonService.choose(detailQuery)
        .then(res => {
          if (res && res.data && res.data.betoni) {
            sveOtpremnice = res.data.betoni
          }
        })
        .catch(err => {
          console.log('Error utrosci ', err )
        })
        data.push({
          sheet: t.sheetMaterialConsumption,
          columns: utrosciColumns(lang),
          content: utrosciRows(sveOtpremnice, this.localDate, lang)
        })
      }

      let settings = {
          fileName: fileNm, // Name of the resulting spreadsheet
          extraLength: 3, // A bigger number means that columns will be wider
          writeOptions: {} // Style options from https://github.com/SheetJS/sheetjs#writing-options
        }

        xlsx(data, settings)

      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#dateheader {
  color:aliceblue;
  text-align: center;
  font-weight: bold;
}
#calendarcolum {
  padding-left: 2px;
  padding-right: 3px;
}
#fullhome {
  padding-left: 10px;
  padding-right: 10px;
}
</style>
